import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { useRefreshedPhoto } from "./hooks";

interface VideoProps {
  photoID: string;
  srcUrl: string;
  srcExpire: string;
  className?: string;
  controls?: boolean;
  autoPlay?: boolean;
  muted?: boolean;
}

const Video = ({
  photoID,
  className = "",
  controls = true,
  autoPlay = false,
  muted = false,
  srcUrl,
  srcExpire,
}: VideoProps) => {
  const { t } = useTranslation("common");
  const refreshedPhoto = useRefreshedPhoto(photoID, srcExpire);

  const src = refreshedPhoto?.srcUrl ?? srcUrl;

  return (
    <video
      key={photoID}
      className={classNames("w-full h-full object-contain", className)}
      src={src}
      controls={controls}
      autoPlay={autoPlay}
      muted={muted}
    >
      {t("images.video_unsupported")}
    </video>
  );
};

export default Video;
